import { format } from "date-fns";

function stableIndex(seed: string, modulo: number): number {
  if (modulo <= 0) return 0;
  let h = 2166136261;
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return Math.abs(h) % modulo;
}

/**
 * Short, neutral time-of-day line for the hub. Same calendar day + user → stable variant.
 */
export function pickHubGreetingLine(opts: { firstName: string; userId?: string }): string {
  const display = opts.firstName.trim() || "there";
  const hour = new Date().getHours();
  const dayKey = format(new Date(), "yyyy-MM-dd");

  const morning = [`Morning, ${display}.`, `Good morning, ${display}.`];
  const afternoon = [`Afternoon, ${display}.`, `Good afternoon, ${display}.`];
  const evening = [`Evening, ${display}.`, `Good evening, ${display}.`];

  const pool = hour < 12 ? morning : hour < 17 ? afternoon : evening;
  const seed = `${dayKey}_${opts.userId ?? "guest"}`;
  return pool[stableIndex(seed, pool.length)] ?? `Hello, ${display}.`;
}
